<div [ngClass]="{blog: isBlog}">
  @if (title) {
    <h1>
      {{ title }}
    </h1>
  }

  <mbnm-navigation-tiles [tileCollection]="cmsData" [enableHero]="true">

  </mbnm-navigation-tiles>

  @if (!cmsData) {
    <mat-spinner color="secondary"></mat-spinner>
  }
</div>
